import { EditableComponent } from '@adobe/aem-react-editable-components';
import clsx from 'clsx';
import { getLocalizedDate } from '../../utils/OfferUtils';
import { stripHtmlToPlainText } from '../../utils/generateJsonSchemaUtils';
import { OffersCountdownEyebrowBannerComp } from './OCountdownEyebrowBanner.comp';
import {
  OffersCountdownEyebrowBannerConfig,
  getBannerVisibility,
  toLocalEndOfDayISOString,
} from './OCountdownEyebrowBanner.utils';

import {
  OCountdownEyebrowBannerAEMProps as OffersCountdownEyebrowBannerAEMProps,
  OCountdownEyebrowBannerModel as OffersCountdownEyebrowBannerModel,
  OCountdownOffersData,
  OCountdownEyebrowBannerPresentationProps as OffersCountdownEyebrowBannerPresentationProps,
} from './OCountdownEyebrowBanner.types';

export { toLocalEndOfDayISOString, getBannerVisibility } from './OCountdownEyebrowBanner.utils';

export const OffersCountdownEyebrowBanner = (props: OffersCountdownEyebrowBannerAEMProps) => {
  const model = (props.model || props || {}) as OffersCountdownEyebrowBannerModel;
  const editableComponentProps = props as unknown as Record<string, unknown>;
  const isAuthorMode = props.isInEditor || props.isAuthorMode;
  const offersData = (props?.offersData || {}) as OCountdownOffersData;
  const offersDataNode = offersData?.responseObject?.offers?.[0] || offersData?.responseObject?.edges?.[0]?.node || {};
  const bookingEndDate = offersDataNode?.bookingEndDate;
  const acceptLanguage = props?.acceptLanguage || offersData?.locale;
  const localizedDate = getLocalizedDate(bookingEndDate ?? '', acceptLanguage, model?.dateFormat ?? '');
  const effectiveExpirationDate = toLocalEndOfDayISOString(bookingEndDate ?? '') ?? '';
  const authoredBodyPrefix = stripHtmlToPlainText(model?.aBody?.bodyText as string);
  const finalBodyText = isAuthorMode
    ? model?.aBody?.bodyText
    : `${authoredBodyPrefix} ${localizedDate}`.replace(/\s+/g, ' ').trim();
  const enableCountdownTimerBanner = model?.enableCountdownTimerBanner ?? true;
  const showWindowDays = model?.showWindowDays ?? 7;
  const hideBanner = !getBannerVisibility(enableCountdownTimerBanner, effectiveExpirationDate ?? '', showWindowDays);
  const presentationProps: OffersCountdownEyebrowBannerPresentationProps = {
    componentId: model?.componentId as string,
    aBody: {
      ...(model?.aBody || {}),
      bodyText: finalBodyText ?? '',
    },
    mTimer: model?.mTimer,
    authorMode: Boolean(isAuthorMode),
    expirationDate: effectiveExpirationDate,
  };
  const isStayBasedOffer = offersDataNode.parentOfferType === 'Stay Based Offer';

  if ((!isAuthorMode && (!enableCountdownTimerBanner || hideBanner)) || !isStayBasedOffer) {
    //hide component if the enableCountdownTimerBanner is set to false
    //hide component if the offer is not a Stay Based Offer
    return null;
  }

  return (
    <EditableComponent config={OffersCountdownEyebrowBannerConfig} {...editableComponentProps}>
      <div
        data-component-name="o-offers-OffersCountdownEyebrowBanner"
        data-testid="offers-OffersCountdownEyebrowBanner"
        id={model?.componentId as string}
        className={clsx(model?.styleclass as string, 'fullbleed m-container-fullbleed')}
      >
        <OffersCountdownEyebrowBannerComp
          key={`${model?.componentId}-${effectiveExpirationDate}`}
          {...presentationProps}
        />
      </div>
    </EditableComponent>
  );
};
